import { render } from "./invateIndex.vue?vue&type=template&id=22f96268&scoped=true"
import script from "./invateIndex.vue?vue&type=script&lang=js"
export * from "./invateIndex.vue?vue&type=script&lang=js"

import "./invateIndex.vue?vue&type=style&index=0&id=22f96268&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f96268"]])

export default __exports__